import React, { useContext } from 'react';

export const UserContext = React.createContext({});
export const useUserContext = () => useContext(UserContext);

export const CustomerContext = React.createContext({});
export const useCustomerContext = () => useContext(CustomerContext);

export const DialogContext = React.createContext({});
export const useDialogContext = () => useContext(DialogContext);

export const PermissionContext = React.createContext({});
export const usePermissionContext = () => useContext(PermissionContext);

export const AppContext = React.createContext({});
export const useAppContext = () => useContext(AppContext);

export const RoleDetailContext = React.createContext({});
export const useRoleDetailContext = () => useContext(RoleDetailContext);

export const FilteredListCountContext = React.createContext();
export const useFilteredListCountContext = () => useContext(FilteredListCountContext);
